import React from 'react';
import CheckboxRadioIcon from './CheckboxRadioIcon.jsx';

const RadioIcon = (props) => {
  return <CheckboxRadioIcon { ...props } type="radio"/>;
};

export default RadioIcon;
